import chat from './chat';
import stock from './stock';
import user from './user';
import base from './base';

const api = {
  chat: chat,     //채팅
  stock: stock,   //주식정보
  user: user,     //사용자
  base: base,     //기본정보
}

export default api;